<template>
  <button
    v-if="showed"
    v-loading.fullscreen.lock="fullScreenLoading"
    @click="pay"
    type="button"
    class="el-button credit-card-button el-button--default"
    :class="{
      'disabled-payment': disabled,
    }"
  >
    <span>
      <svg
        viewBox="0 0 452.9 101.10000000000001"
        xmlns="http://www.w3.org/2000/svg"
        width="70"
      >
        <path
          d="M79.7 0H57.4c0 18.3-8.4 35-23 46l-8.8 6.6 34.2 46.6h28.1L56.4 56.3C71.3 41.5 79.7 21.5 79.7 0zM0 0h22.8v99.2H0zM94.5 0H116v99.2H94.5zM304.6 28.7c-8.2 0-16 2.5-21.2 9.6v-7.7H263v68.6h20.7v-36c0-10.4 7-15.5 15.4-15.5 9 0 14.2 5.4 14.2 15.4v36.2h20.5V55.6c0-16-12.7-26.9-29.2-26.9zM181 30.6V35c-5.8-4-12.8-6.3-20.4-6.3-20 0-36.2 16.2-36.2 36.2s16.2 36.2 36.2 36.2c7.6 0 14.6-2.3 20.4-6.3v4.4h20.5V30.6zm-18.7 51.9c-10.3 0-18.6-7.9-18.6-17.6s8.3-17.6 18.6-17.6 18.6 7.9 18.6 17.6-8.3 17.6-18.6 17.6zM233.3 39.5v-8.9h-21v68.6h21.1v-32c0-10.8 11.7-16.6 19.8-16.6h.2v-20c-8.3 0-16 3.6-20.1 8.9zM397.6 30.6V35c-5.8-4-12.8-6.3-20.4-6.3-20 0-36.2 16.2-36.2 36.2s16.2 36.2 36.2 36.2c7.6 0 14.6-2.3 20.4-6.3v4.4h20.5V30.6zm-18.7 51.9c-10.3 0-18.6-7.9-18.6-17.6s8.3-17.6 18.6-17.6 18.6 7.9 18.6 17.6c.1 9.7-8.3 17.6-18.6 17.6zM434 32.6c0-1-.7-1.6-1.8-1.6h-1.9v5.2h.9v-1.9h1l.8 1.9h1l-.9-2.1c.6-.3.9-.8.9-1.5zm-1.8.8h-1v-1.6h1c.6 0 .9.3.9.8s-.2.8-.9.8z"
        />
        <path
          d="M431.9 28.8c-2.7 0-4.9 2.2-4.9 4.9.1 2.7 2.2 4.9 4.9 4.9s4.9-2.2 4.9-4.9-2.2-4.9-4.9-4.9zm0 8.9c-2.2 0-3.9-1.8-3.9-4s1.8-4 3.9-4c2.2 0 3.9 1.8 3.9 4s-1.8 4-3.9 4zM440 74.9c-7.1 0-12.9 5.8-12.9 12.9s5.8 12.9 12.9 12.9 12.9-5.8 12.9-12.9c0-7.2-5.8-12.9-12.9-12.9z"
        />
      </svg>
    </span>
  </button>
</template>

<script>
import paymentMixin from "./payment-mixin";

export default {
  name: "KlarnaExpress",
  mixins: [paymentMixin],
  methods: {
    sendLogs() {
      this.$amplitude.logEvent("Payment page event Klarna button clicked", {
        qrCode: this.qrCodes.join(","),
        amount: this.amount,
        currency: this.currency,
      });
    },
    async pay() {
      this.fullScreenLoading = true;
      this.sendLogs();
      await this.$axios
        .post("/api/v1/session", {
          cancelUrl: `${
            process.env.VUE_APP_BASE_URL
          }/#/pay-confirm/${this.qrCodes.join(",")}/${this.currency}/${
            this.amount
          }`,
          successUrl: `${process.env.VUE_APP_BASE_URL}/#/receipt`,
          qrCodes: this.paymentObject,
          clientPaysFee: !!this.clientPaysFee,
          amount: this.amount,
          currency: this.currency,
          defaultPaymentType: "Klarna",
        })
        .then((response) => {
          if (response.data?.txId) {
            this.$cookie.delete("txId");
            this.$cookie.set("txId", response.data.txId);
            location.href = response.data.url;
          } else {
            this.$message.error(this.$t("form.something-wrong"));
            this.fullScreenLoading = false;
          }
        })
        .catch(() => {
          this.fullScreenLoading = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.credit-card-button::v-deep {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 55px;
  width: 100%;
  background: #fff;
  border: 1px solid #2c2e2f;
  border-radius: 4px;
  margin: 12px auto 0 auto;

  span {
    color: #000;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      margin-right: 8px;
    }

    p {
      margin: 0;
      font-family: "Raleway SemiBold", serif;
      font-size: 24px;
    }
  }
}
</style>
